import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';
import getResultsTableTitle from '../../helpers/getResultsTableTitle';

const PillTabsContent = ({
  tripCount,
  searchInProgress,
  trip,
  selectedFlightGroups,
  children,
  canExchange,
}) => (
  <Fragment>
    {searchInProgress && <Loader />}
    <div className="results-table">
      <div className="results-table__title">
        {getResultsTableTitle(!!selectedFlightGroups[tripCount + 1], canExchange)}
        <span>{` ${trip.origin} - ${trip.destination}`}</span>
      </div>
      {children}
    </div>
  </Fragment>
);

PillTabsContent.propTypes = {
  tripCount: PropTypes.number.isRequired,
  searchInProgress: PropTypes.bool.isRequired,
  trip: PropTypes.shape({
    origin: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
  }).isRequired,
  selectedFlightGroups: PropTypes.shape({}).isRequired,
  children: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  canExchange: PropTypes.bool.isRequired,
};

export default PillTabsContent;
